import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=5939819c&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"
import style0 from "./finance.vue?vue&type=style&index=0&id=5939819c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939819c",
  null
  
)

export default component.exports